import { render, staticRenderFns } from "./classifyList.vue?vue&type=template&id=50aaad69&scoped=true&"
import script from "./classifyList.vue?vue&type=script&lang=js&"
export * from "./classifyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50aaad69",
  null
  
)

export default component.exports